import { z } from 'zod';

// Customer-app roles — used by RLS policies, route guards, and JWT custom
// claims. Keep in sync with the Postgres enum in
// supabase/migrations/0001_init.sql. The persisted `admin` value means studio
// admin, not Pirouette/Tygart Nexus operator access; operator access lives in
// the separate operator Supabase project and operator console.

export const roleSchema = z.enum(['admin', 'faculty', 'parent', 'dancer']);
export type Role = z.infer<typeof roleSchema>;
export type StudioRole = Role;

// Convenience predicates — match supabase JWT custom-claim pattern.
export const ROLE_ADMIN = 'admin' as const satisfies Role;
export const ROLE_STUDIO_ADMIN = ROLE_ADMIN;
export const ROLE_FACULTY = 'faculty' as const satisfies Role;
export const ROLE_PARENT = 'parent' as const satisfies Role;
export const ROLE_DANCER = 'dancer' as const satisfies Role;

export function isAdministrative(role: Role): boolean {
  return role === ROLE_ADMIN;
}

export function canMarkAttendance(role: Role): boolean {
  return role === ROLE_ADMIN || role === ROLE_FACULTY;
}

export function canEditBilling(role: Role): boolean {
  return role === ROLE_ADMIN;
}
